module.exports = {
  en:
    'Online instructional materials for COMP 227 from the University of the Pacific',
};
